export default "__VITE_ASSET__DUhhAUR___"